import { EmailTypes } from './types';

type MapEmails = {
  [key in EmailTypes]: string;
};

export const MAP_EMAILS_TO_FIELDS: MapEmails = {
  [EmailTypes.welcome]: 'welcome_email',
  [EmailTypes.registrationConfirm]: 'registration_confirmation_email',
  [EmailTypes.emailChange]: 'email_change_verification_email',
  [EmailTypes.passwordChange]: 'password_change_verification_email',
  [EmailTypes.verificationCode]: 'passwordless_code_email',
  [EmailTypes.verificationLinkCode]: 'passwordless_link_email',
  [EmailTypes.blockedAccount]: 'registration_confirmation_email',
  [EmailTypes.mfaCode]: 'mfa_code_email',
  [EmailTypes.mfaSettingsChange]: 'mfa_settings_changed_email',
  [EmailTypes.newsSubscribe]: 'newsletter_subscribe_email',
  [EmailTypes.custom]: 'registration_confirmation_email'
};
